<template>
  <Card>
    <p slot="title">激活信息列表</p>
    <template slot="extra">
      <Button type="primary" icon="md-cloud-upload" @click="exportAction()"
        >报表导出</Button
      >
      <Button type="primary" icon="ios-search" @click="handleSearch()"
        >查询</Button
      >
      <Button type="primary" icon="md-sync" @click="reset()">刷新</Button>
    </template>
    <Row>
      <Col span="24">
        <Select
          v-model="params.bgRpCode"
          placeholder="请选择大区"
          class="public-inp"
        >
          <!-- <Option
            v-for="(item, index) in provinceList"
            :key="index"
            :value="item.code"
            >{{ item.name }}</Option
          > -->
        </Select>

        <Select
          v-model="params.provinceId"
          placeholder="请选择省份"
          class="public-inp"
          @on-change="provinceChange"
        >
          <Option
            v-for="(item, index) in provinceList"
            :key="index"
            :value="item.code"
            >{{ item.name }}</Option
          >
        </Select>

        <Select
          v-model="params.cityId"
          placeholder="请选择城市"
          class="public-inp"
        >
          <Option
            v-for="(item, index) in cityList"
            :key="index"
            :value="item.code"
            >{{ item.name }}</Option
          >
        </Select>
        <Select
          v-model="params.channelCode"
          placeholder="请选择渠道"
          class="public-inp"
        >
          <Option
            v-for="(item, index) in channelList"
            :key="index"
            :value="item.code"
            >{{ item.name }}</Option
          >
        </Select>

        <Select
          v-model="params.grade"
          placeholder="请选择门店等级"
          class="public-inp"
        >
          <!-- <Option
            v-for="(item, index) in provinceList"
            :key="index"
            :value="item.code"
            >{{ item.name }}</Option
          > -->
        </Select>

        <Input
          v-model="params.mdmCode"
          placeholder="请输入达能系统门店码"
          class="public-inp"
        />
        <Input
          v-model="params.name"
          placeholder="请输入物料名称"
          class="public-inp"
        />

        <Input
          v-model="params.qrCode"
          placeholder="请输入二维码编码"
          class="public-inp"
        />
        <!-- <Select
          v-model="params.status"
          placeholder="请选择二维码状态"
          class="public-inp"
        >
        </Select> -->
        <Select
          v-model="params.materialTypeCode"
          placeholder="请选择陈列类型"
          class="public-inp"
        >
          <Option
            v-for="(item, index) in typeCodeList"
            :key="index"
            :value="item.materialTypeCode"
            >{{ item.name }}</Option
          >
        </Select>
        <Input
          v-model="params.retCode"
          placeholder="请输入达e购ID"
          class="public-inp"
        />
        <Input
          v-model="params.loginAccount"
          placeholder="请输入门店账号"
          class="public-inp"
        />
        <DatePicker
          type="daterange"
          :options="options"
          placement="bottom-start"
          placeholder="请选择激活时间"
          v-model="seTime"
          class="public-inp"
        ></DatePicker>
      </Col>
      <Col span="24">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="tbList"
        >
          <template slot-scope="{ index }" slot="sort">
            {{ (params.pageNum - 1) * params.pageSize + index + 1 }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <a href="javascript:;" @click="toDetail(row)">查看</a>
          </template>
        </Table>
        <Page
          :total="total"
          :page-size="params.pageSize"
          :current="params.pageNum"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          @on-change="pageChange"
          @on-page-size-change="pageSizeChange"
          class="public-page"
        />
      </Col>
    </Row>
  </Card>
</template>

<script>
const columns = [
  {
    title: "序号",
    slot: "sort",
    fixed: "left",
    width: 66,
  },
  {
    title: "渠道",
    key: "channelCode",
    width: 100,
  },
  {
    title: "门店等级",
    key: "grade",
    width: 100,
  },
  {
    title: "达能系统门店码",
    key: "mdmCode",
    width: 100,
  },
  {
    title: "大区",
    key: "bgRpName",
    width: 100,
  },
  {
    title: "省份",
    key: "provinceName",
    width: 100,
  },
  {
    title: "城市",
    key: "cityName",
    width: 100,
  },
  {
    title: "门店账号",
    key: "loginAccount",
    width: 100,
  },
  {
    title: "物料名称",
    key: "name",
    width: 100,
  },
  {
    title: "二维码编码",
    key: "qrCode",
    width: 100,
  },
  {
    title: "达e购ID",
    key: "retCode",
    width: 100,
  },
  {
    title: "激活门店",
    key: "retName",
    width: 100,
  },
  {
    title: "门店类型",
    key: "retType",
    width: 100,
  },
  {
    title: "父级门店达e购ID",
    key: "parentRetCode",
    width: 100,
  },
  {
    title: "激活时间",
    key: "activationTime",
    width: 100,
  },
  {
    title: "激活经度",
    key: "longitude",
    width: 100,
  },
  {
    title: "激活纬度",
    key: "latitude",
    width: 100,
  },
  {
    title: "扫码次数",
    key: "scanNum",
    width: 100,
  },
  {
    title: "打卡次数",
    key: "punchNum",
    width: 100,
  },
  {
    title: "陈列类型",
    key: "materialType",
    width: 100,
  },
  {
    title: "操作",
    slot: "action",
    fixed: "right",
    width: 130,
  },
];
const options = {
  shortcuts: [
    {
      text: "1 week",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        return [start, end];
      },
    },
    {
      text: "1 month",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        return [start, end];
      },
    },
    {
      text: "3 months",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        return [start, end];
      },
    },
  ],
};
export default {
  data() {
    return {
      typeCodeList: [],
      channelList: [
        { name: "GT", code: "GT" },
        { name: "KA", code: "KA" },
        { name: "OTHERS", code: "OTHERS" },
      ],
      options,
      params: {
        activationTimeBegin: "",
        activationTimeEnd: "",
        bgRpCode: "",
        channelCode: "",
        cityId: "",
        grade: "",
        loginAccount: "",
        materialTypeCode: "",
        mdmCode: "",
        name: "",
        pageNum: 1,
        pageSize: 10,
        provinceId: "",
        qrCode: "",
        retCode: "",
        status: "",
      },
      seTime: [],
      total: 0,
      columns,
      tbList: [],
      loading: false,
      provinceList: [],
      cityList: [],
    };
  },
  created() {
    this.getList();
    this.getBaseAreaQueryAll();
    this.getMaterialType();
  },
  methods: {
    handleSearch() {
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.getList();
    },
    getMaterialType() {
      this.$api.materManType().then((res) => {
        if (res.code == 200) {
          this.typeCodeList = res.data;
        }
      });
    },
    provinceChange(e) {
      let data = this.provinceList,
        cityList = [];
      this.params.cityId = "";
      data.map((item) => {
        item.children.forEach((i0) => {
          if (this.params.provinceId && this.params.provinceId == i0.parent) {
            cityList.push(i0);
          }
        });
      });
      this.cityList = cityList;
    },
    getBaseAreaQueryAll() {
      this.$api.areaQueryAll().then((res) => {
        if (res.code == 200) {
          let cityList = [];
          this.provinceList = res.data;
          res.data.map((item) => {
            item.children.forEach((i0) => {
              cityList.push(i0);
            });
          });
          this.cityList = cityList;
        }
      });
    },

    initTime(t, i) {
      if (!t[i]) {
        return "";
      }
      let d = t[i];
      let str = new Date(d);
      return this.tools.formatDate(str, true);
    },
    getList() {
      this.loading = true;
      let params = this.params;
      params.activationTimeBegin = this.initTime(this.seTime, 0);
      params.activationTimeEnd = this.initTime(this.seTime, 1);
      this.$api.activationList(params).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.tbList = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    // 页码
    pageChange(d) {
      this.params.pageNum = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.params.pageSize = d;
      this.getList();
    },
    // 重置
    reset() {
      for (let key in this.params) {
        this.params[key] = "";
      }
      this.seTime = [];
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.$nextTick(() => {
        this.getList();
      });
    },
    toDetail(e) {
      this.$router.push({
        path: "activaDetail",
        query: {
          code: e.code,
        },
      });
    },
    exportAction() {
      let data = this.params;
      this.$api.activationnExport(data).then((res) => {
        if (res.code == "200") {
          try {
            let elemIF = document.createElement("iframe");
            elemIF.src = res.data.url;
            elemIF.style.display = "none";
            document.body.appendChild(elemIF);
          } catch (e) {
            this.$Message.error("下载异常！");
          }
        } else {
          this.$Message.error("导出失败" + res.message);
        }
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/material/activationList.vue